module.exports = __webpack_public_path__ + "static/media/small-soldiers2.a4c86294.gif";